import { render } from "./AppPageLoader.vue?vue&type=template&id=a7301128&ts=true"
import script from "./AppPageLoader.vue?vue&type=script&lang=ts"
export * from "./AppPageLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__